import React from 'react';
import { Typography, Button, Container, Box, Paper } from '@material-ui/core';
import { Link } from '@reach/router'; // Changed import for Link
import CheckCircleOutlineIcon from '@material-ui/icons/CheckCircleOutline';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles((theme) => ({
  container: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    textAlign: 'center',
  },
  paper: {
    padding: theme.spacing(4),
    marginTop: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
  },
  icon: {
    fontSize: '4rem',
    color: theme.palette.success.main,
    marginBottom: theme.spacing(2),
  },
  button: {
    marginTop: theme.spacing(3),
  },
}));

// Changed to receive props, including paymentOrderId from @reach/router path parameter
function PolarSHSuccessPage(props) {
  const classes = useStyles();
  const { paymentOrderId } = props; // Get paymentOrderId from props

  return (
    <Container component="main" maxWidth="sm" className={classes.container}>
      <Paper className={classes.paper} elevation={3}>
        <CheckCircleOutlineIcon className={classes.icon} />
        <Typography variant="h4" component="h1" gutterBottom>
          Payment Successful!
        </Typography>
        <Typography variant="body1">
          Your payment has been processed successfully. Your order details will be updated shortly.
        </Typography>
        {paymentOrderId && (
          <Typography variant="body2" color="textSecondary" style={{ marginTop: 10 }}>
            Payment ID: {paymentOrderId}
          </Typography>
        )}
        <Button
          component={Link}
          to="/my-orders" // Assuming a route to view user's orders
          variant="contained"
          color="primary"
          className={classes.button}
        >
          View My Orders
        </Button>
        <Button
          component={Link}
          to="/" // Link to homepage
          variant="outlined"
          color="secondary"
          className={classes.button}
          style={{ marginLeft: 10 }}
        >
          Go to Homepage
        </Button>
      </Paper>
    </Container>
  );
}

export default PolarSHSuccessPage;
